<template>
    <form ref="quizForm" method="POST" @submit.prevent="save" id="quiz-student">
        <div class="row">
            <div class="col-8">
                <h2>{{ quiz.name }}</h2>
            </div>
            <div class="col-4">
                <div class="text-right" v-if="quiz.exam_set_clock && !passedQuiz && currentTime && !hasResponses">
                    <span class="quiz-timer-label">{{ trans("course.student_quiz_time_left") }}:</span>
                    <span class="quiz-timer-clock">{{
                            currentTime ? `${("0" + currentTime.hours).slice(-2)}:${("0" + currentTime.minutes).slice(-2)}:${("0" + currentTime.seconds).slice(-2)}` : ""
                        }}</span>
                </div>
            </div>
        </div>

        <div class="row quiz-bar">
            <div class="col-12 col-lg-6 quiz-col">
                <!-- <div class="quiz-wrap-container"> -->
                <i class="fas fa-hourglass-half"></i>
                <div class="quiz-item-title">
                    {{ trans("course.student_quiz_time_limit") }}:
                </div>
                <div class="quiz-time">{{ quiz.time ? quiz.time : trans("course.student_quiz_times_unlimited") }}
                    {{ quiz.time ? "min" : "" }}
                </div>
                <!-- </div> -->
            </div>
            <div class="col-12 col-lg-6 quiz-col">
                <!-- <div class="quiz-wrap-container"> -->
                <i class="far fa-calendar-check"></i>
                <div class="quiz-item-title">
                    {{ trans("course.student_quiz_min_score_to_pass") }}
                </div>
                <div class="quiz-score">{{ quiz.min_score }}{{
                        quiz.min_score_type == "points" ? ` ${trans("course.student_point")}` : "%"
                    }}
                </div>
                <!-- </div> -->
            </div>
            <div class="col-12 col-lg-6 quiz-col" v-if="quiz.quiz_type != 'essay'">
                <!-- <div class="quiz-wrap-container"> -->
                <i class="far fa-question-circle"></i>
                <div class="quiz-item-title">{{ trans("course.student_quiz_questions") }}</div>
                <div class="quiz-score">{{ questionsNo }}</div>
                <!-- </div> -->
            </div>
            <div class="col-12 col-lg-6 quiz-col" v-if="quiz.quiz_type != 'essay'">
                <!-- <div class="quiz-wrap-container"> -->
                <i class="fas fa-redo-alt"></i>
                <div class="quiz-item-title">
                    {{ trans("course.student_quiz_can_taken") }}
                </div>
                <div class="quiz-score" :class=" quiz.repeat_times - repeated == 0 ? 'quiz-score-red' : ''">
                    {{
                        quiz.repeat_times ? quiz.repeat_times - repeated : trans("course.student_quiz_times_unlimited")
                    }} {{ trans("course.student_quiz_times") }}
                </div>
                <!-- </div> -->
            </div>
        </div>
        <div v-if="hasResponses" class="alert alert-info mt-2 quiz-score-message" role="alert">
            <template v-if="resultsAvailableNow">
                <div v-if="quiz.quiz_type == 'essay'">
                    <div v-if="Boolean(essayPending) === false">
                        <b>You {{ quiz.min_score <= essayTeacherPoints ? "passed" : "failed" }} {{ quiz.quiz_type }}!</b>
                        <div class="quiz-score-message1">{{ trans("course.student_quiz_points") }}:
                            <span :class="{
                                'passed-quiz-score' : quiz.min_score <= essayTeacherPoints,
                                'failed-quiz-score': quiz.min_score > essayTeacherPoints
                            }">
                                {{ essayTeacherPoints }}
                            </span>!
                        </div>
                    </div>
                    <b v-else>{{ trans("course.student_quiz_responses_sent_msg") }}!</b>
                </div>
                <div v-else>
                    <template v-if="passedQuiz">
                        <b>{{ trans("course.student_quiz_passed_msg") }}!</b>
                        <button type="submit"
                                v-if=" ((quiz.min_score_type == 'points' && points < maxPoints) || (quiz.min_score_type == 'percent' && percent < 100)) && !doneQuiz"
                                class="btn btn-retake">
                            {{ trans("course.student_quiz_retake_for_better_score") }}
                        </button>
                    </template>
                    <template v-if="doneQuiz && !passedQuiz">
                        {{ trans("course.student_quiz_failed_msg") }}!
                    </template>
                    <div class="quiz-score-message1">
                        {{ trans("course.student_quiz_your_score") }}
                        <span :class="{
                            'passed-quiz-score' : this.passedQuiz,
                            'failed-quiz-score': !this.passedQuiz
                        }">
                            {{ quiz.min_score_type == "points" ? points + ` ${trans("course.student_point")}` : percent + "%" }}!
                        </span>
                    </div>
                    <div class="quiz-score-message2" v-if="!passedQuiz && !doneQuiz">
                        {{ trans("course.student_quiz_answered_correct_msg1") }}
                        <span class="answer-score-bold">{{ correctAnswers }}</span>
                        {{ trans("course.student_quiz_answered_correct_msg2") }}
                        <span class="answer-score-bold">{{ totalQuestions ?? questions.filter(question => question.show_title).length }}</span>
                        {{ trans("course.student_quiz_answered_correct_msg3") }}!
                    </div>
                </div>
            </template>
            <template v-else>
                <span>{{ trans("quizzes.custom_messages.delay").replace(':date', resultsAvailableAt) }}</span>
            </template>
        </div>
        <div class="mt-3" v-if="quiz.show_description && quiz.content && quiz.content != ''">
            <course-blocks v-on:trigger-keep="triggerKeep" :idl="idl" :ids="ids" :section="section" :token="token"
                           :content="JSON.parse(quiz.content)"></course-blocks>
        </div>
        <div class="overflow-hidden" v-if="quiz.quiz_type == 'essay'">
            <template v-if="hasResponses && Boolean(essayPending) === false && resultsAvailableNow">
                <div class="border-course mb"></div>
                <div class="mt-3">
                    <label class="font-weight-bold">{{ trans("course.student_quiz_teacher_response") }}:</label>
                    <div v-html="essayTeacherResponse"></div>
                </div>
            </template>
            <div class=" border-course mb"></div>
            <div class="form-group">
                <ckeditor v-if="questions.length" v-model="questions[0].userResponses" class="editor-border"
                          :editor="editor" :config="editorConfig"
                          :disabled="!!(essayPending || hasResponses)"></ckeditor>
            </div>
        </div>
        <div v-for="(question, idl) in this.questions" v-if="quiz.quiz_type != 'essay' && question.show_title && resultsAvailableNow"
             class="question border-bottomn mt-4"
             :class="{
                'correct-answer-design': showResults && question.correct && quiz.quiz_type !== 'essay',
                'wrong-answer-design': showResults && !question.correct && quiz.quiz_type !== 'essay'
             }"

             :id="'chapter-' + questions.id">
            <!-- :class="{
                'correct-answer-design': showResults && question.correct && quiz.quiz_type !== 'essay',
                'wrong-answer-design': !passedQuiz && !doneQuiz && showResults && !question.correct
             }" -->
            <!-- v-bind:class="[ question.correct ? 'correct-answer-design' : (showResults && !question.correct) ? 'wrong-answer-design' : '' ]" -->
            <!-- DESIGN FOR CORRECT AND WRONG ANSWER(APPLYING THE BORDER) -->
            <h3 class="quiz-title">{{ question.name ? question.name : "Untitled Question" }}</h3>
            <!-- <div v-if=" showResults && question.correct && quiz.quiz_type != 'essay' " class="alert alert-success" role="alert" > {{ trans("course.student_quiz_correct_answer_msg") }} </div> -->
            <!-- <div v-if=" !passedQuiz && !doneQuiz && showResults && !question.correct " class="alert alert-danger" role="alert" > {{ trans("course.student_quiz_wrong_answer_msg") }} </div> -->
            <div v-if="question.show_description" v-html="question.description"></div>
            <template v-if=" !['reorder', 'reorder_images', 'essay', 'content'].includes( question.type )">
                <div class="row">
                    <template v-if="question.type == 'free_text'">
                        <div class="form-group col-12">
                            <input v-model="questions[idl].userResponses"
                                   class="form-control" type="text" :disabled="doneQuiz || hasResponses"/>
                            <template v-if="showResults && solutions">
                                <div class="pt-2">
                                    {{ trans("quiz-creator.accepted_answers") }}
                                </div>
                                <template v-for="(solution, idx) in solutions[idl]">
                                    <template v-if="solution.correct">
                                        <div class="pl-2" style="font-weight: normal">
                                            {{ solution.text }}
                                        </div>
                                    </template>
                                </template>
                            </template>
                        </div>
                    </template>
                    <div v-else v-for="(response, idr) in question.responses" class="question-section col-12">
                        <template v-if="['true', 'single'].includes(question.type)">
                            <div class="form-check"
                                 :class=" solutions && showResults && solutions[idl][idr].correct ? 'correct-solutions' : (showResults && solutions && !question.correct) ? 'wrong-solutions' : ''">
                                <input v-model="questions[idl].userResponses" @change="selectOptions(question.id, idr)"
                                       class="form-check-input" type="radio" :value="idr" :name="`radio-${question.id}`"
                                       :id="`radio-${question.id}-${idr}`" :disabled="doneQuiz || hasResponses"/>
                                <label class="form-check-label" :for="`radio-${question.id}-${idr}`">
                                    <template v-if="question.type === 'true'">
                                        {{ trans("quiz-creator.answers." + response.text) }}
                                    </template>
                                    <template v-else>{{
                                            response.text ? response.text : "Untitled Response"
                                        }}
                                    </template>
                                </label>
                            </div>
                        </template>
                        <template v-if="question.type == 'multiple'">
                            <div class="form-check mb-1"
                                 :class="solutions && showResults && solutions[idl][idr].correct ? 'correct-solutions' : (showResults && solutions && !question.correct) ? 'wrong-solutions' : ''">
                                <input v-model="questions[idl].userResponses" @change="selectOptions()"
                                       class="form-check-input" type="checkbox" :value="idr"
                                       :name="`multiple-${question.id}[]`" :id="`multiple-${question.id}-${idr}`"
                                       :disabled="doneQuiz || hasResponses"/>
                                <label class="form-check-label" :for="`multiple-${question.id}-${idr}`">{{
                                        response.text ? response.text : "Untitled Response"
                                    }}</label>
                            </div>
                        </template>
                    </div>
                </div>
            </template>
            <template v-if="['reorder', 'reorder_images'].includes(question.type)">
                <draggable v-model="question.userResponses" draggable=".reorder-drag" :swapThreshold="0.5"
                           :scroll="true" :scroll-speed="2000" :scroll-sensitivity="10" class="row row-eq-height">
                    <div v-for="(response, idr) in question.userResponses"
                         class="reorder-drag col-12 col-md-6 col-lg-6 col-xl-4 mt-1 d-table position-relative w-100 mb-1 pl-2"
                         :class=" question.type == 'reorder_images' ? 'reorder-drag-image' : 'reorder-drag-text'">
                        <div class="form-check d-table-cell">
                            <div class="icon-dragable-question">
                                <!-- <img
                                    src="/images/drag-grey.png"
                                    loading="lazy"
                                    alt=""
                                    class=""
                                    style="opacity: 1;"
                                    draggable="false"
                                /> -->
                                <div class="course-icon-wrap handle hover-image">
                                    <img :src="'/images/drag-grey.png'" loading="lazy" alt="" class="inactive-icon"
                                         style="opacity: 1;"/>
                                    <img :src="'/images/drag-orange.png'" loading="lazy" alt="" class="active-icon"
                                         style="opacity: 0;"/>
                                </div>
                            </div>
                            <!--                            <div class="handle hover-image handle-quiz">-->
                            <!--                                <img :src="'/images/drag-grey.png'" loading="lazy" alt="" class="inactive-icon" style="opacity: 1;">-->
                            <!--                                <img :src="'/images/drag-orange.png'" loading="lazy" alt="" class="active-icon" style="opacity: 0;">-->
                            <!--                            </div>-->
                            <img v-if="question.type == 'reorder_images'" class="question-img"
                                 :src="response.image + '?token=' + token"/>
                            <label v-if="question.type == 'reorder'" class="form-check-label m-2">{{
                                    response.text ? response.text : "Untitled Response"
                                }}</label>
                        </div>
                    </div>
                </draggable>
            </template>
        </div>
        <div class="d-flex">
            <button v-if="!preview
                        && !passedQuiz
                        && !doneQuiz
                        && !coachView
                        && quiz.quiz_type === 'essay'
                        && !hasResponses"
                    type="button"
                    class="btn btn-primary mt-3 mb-3"
                    @click.prevent="saveQuizResponses()"
            >
                <span v-if="!hasResponses">{{ trans("course.student_quiz_save_results") }}</span>
            </button>
            <button v-if="canViewSubmitButton" type="submit" class="btn btn-primary mt-3 mb-3 ml-auto">
                <span v-if="!hasResponses">{{ trans("course.student_quiz_submit") }}</span>
                <span v-else>{{ trans("course.student_quiz_repeat_quiz") }}</span>
            </button>
        </div>

    </form>
</template>

<script>
import moment from "moment";
import CustomEditor from "../../includes/ck-editor/ck-editor-custom";
import toastr from "toastr";

export default {
    name: "course-quiz-part",
    components: {},
    async created() {
        // if not private, load them ( to show them ), otherwise
        // questions are going to be loaded in getUserQuiz only once

        if (this.quiz.is_private !== 1 || this.coachView) {
            await this.getQuizQuestions(this.quiz.id);
        }

        await this.getUserQuiz();
    },
    destroyed() {
        const body = document.body;
        body.classList.remove("quiz");
    },
    props: {
        courseId: Number,
        studentCourseId: Number,
        quiz: Object,
        user: Object,
        preview: Number,
        freeCourse: Number,
        ids: Number,
        idl: Number,
        section: Object,
        coachView: false,
    },
    watch: {},
    data: function () {
        return {
            pauseTimer: true,
            deadline: null,
            currentTime: null,
            token: null,
            questions: [],
            solutions: null,
            repeated: 0,
            showResults: false,
            hasResponses: false,
            passedQuiz: false,
            doneQuiz: false,
            correctAnswers: 0,
            totalQuestions: 0,
            percent: 0,
            points: 0,
            essayPending: false,
            essayTeacherResponse: "",
            essayTeacherPoints: null,
            questionsNo: 0,
            editor: CustomEditor,
            editorConfig: {
                language: document.documentElement.lang,
                removePlugins: ["imageUpload", "mediaEmbed"],
                link: {
                    addTargetToExternalLinks: true,
                    defaultProtocol: "http://"
                },
                toolbar: {
                    removeItems: ["uploadImage", "mediaEmbed"]
                }
            },
            countdownTimer: null,
            submittingResults: false,
            delayResultsUntil: null,
            quizIsPrivate: false,
        };
    },
    mounted() {
        const body = document.body;
        body.classList.add("quiz");
    },
    beforeDestroy() {
        if(this.countdownTimer && !this.hasResponses
            && !this.pauseTimer
            && !this.submittingResults) {
            this.$swal
                .fire({
                    title: window.trans.course.quiz.warning_modal[this.quiz.quiz_type].title,
                    icon: "warning",
                    html: window.trans.course.quiz.warning_modal[this.quiz.quiz_type].warning,
                    showConfirmButton: false,
                    showCancelButton: true,
                    focusCancel: true,
                    cancelButtonText: window.trans.course.quiz.buttons.i_understand,
                    onAfterClose: () => window.scrollTo(0,0),
                })
        }

        if (this.quiz.quiz_type !== 'essay'
            && !this.hasResponses
            && !this.pauseTimer
            && !this.submittingResults) {
            this.saveQuizResponses();
        }
        this.stopTimer();
    },
    computed: {
        maxPoints: function () {
            return this.questions.filter(question => question.show_title)
                .reduce(function (sum, question) {
                    return sum + parseInt(question.points || 0);
                }, 0);
        },
        resultsAvailableNow: function () {
            return !this.delayResultsUntil || moment(this.delayResultsUntil) <= moment();
        },
        resultsAvailableAt: function () {
            if (!this.delayResultsUntil) {
                return "";
            }
            return moment(this.delayResultsUntil).format("DD-MM-YYYY HH:mm");
        },
        canViewSubmitButton: function () {
            return !this.preview && !this.freeCourse && !this.passedQuiz && !this.doneQuiz && !this.coachView && this.resultsAvailableNow;
        }
    },
    methods: {
        stopTimer() {
            // console.log(this.countdownTimer)
            if(this.countdownTimer) {
                clearTimeout(this.countdownTimer);
                this.countdownTimer = null;
                // console.log('stoped timer');
            }
        },
        triggerKeep(data) {
            //console.log(data);
            this.$emit("trigger-keep", data ?? {});
        },
        getQuizQuestions: async function (id) {
            let $end = route('get-course-quiz-questions', {id});
            if (this.freeCourse) {
                $end = route('free-course-quiz-questions', {id});
            }
            let self = this;

            if (self.quiz.quiz_type == "essay") {
                self.questionsNo = 1;
                let responses = {responses: "", userResponses: ""};
                self.questions.push(responses);

                return;
            }
            return axios
                .get($end)
                .then(function (res) {
                    let response = res.data.questions;
                    self.token = res.data.token;

                    response.forEach(function (question, idx) {
                        if (question.show_title) {
                            self.questionsNo++;
                        }
                        let responses = question.responses;
                        if (
                            ["reorder", "reorder_images"].includes(
                                question.type
                            )
                        ) {
                            if (responses) {
                                response[idx].responses = responses;
                                response[idx].userResponses = responses;
                            }
                        } else {
                            response[idx].responses = responses;
                            response[idx]["userResponses"] =
                                question.type == "essay" ? "" : [];
                        }
                        response[idx]["correct"] = false;
                    });
                    self.questions = response;
                })
                .catch(err => {
                    console.log(err);
                    this.$data.loader = false;
                });
        },
        selectOptions: function () {
        },
        save: function () {
            this.submittingResults = true;
            let self = this;

            let $end = "/api/send-quiz-responses";

            let data = {
                questions: this.questions,
                user: this.user,
                lessonsNo: this.lessonsNo,
                quizzesNo: this.quizzesNo,
                // quizzesNoCert: this.quizzesNoCert,
                quiz_id: this.quiz.id,
                course_id: this.courseId,
                reset: false,
                studentCourseId: this.studentCourseId
            };

            if (this.hasResponses) {
                data.reset = true;
            }
            window.scrollTo(0, 0);

            axios
                .post($end, data)
                .then(response => {
                    response = response.data;

                    self.delayResultsUntil = response?.quiz_data?.delay_results_until ?? false;

                    if (typeof response.reset != "undefined") {
                        this.submittingResults = false;
                        self.hasResponses = false;
                        self.passedQuiz = false;
                        self.doneQuiz = false;
                        self.showResults = false;
                        self.correctAnswers = 0;
                        self.percent = 0;
                        self.points = 0;
                        self.questionsNo = 0;

                        if (self.quiz.exam_set_clock) {
                            self.deadline = moment()
                                .add(self.quiz.time, "minutes")
                                .format("M/D/YYYY hh:mm:ss A");
                            self.stopTimer();
                            self.countdownTimer = setTimeout(self.countdown, 1);
                        }

                        this.getQuizQuestions(this.quiz.id);

                        self.$forceUpdate();
                        return;
                    } else if (response?.quiz_data?.delay_results_until || response.quiz_data.is_private) {
                        this.questions = [];
                    }

                    self.showResults = true;
                    self.hasResponses = true;

                    self.correctAnswers = response.correctNo;
                    self.totalQuestions = response.questionCount;

                    let responses = response.responses;

                    if (self.quiz.quiz_type === "essay") {
                        self.doneQuiz = true;
                        self.essayPending = true;

                        if (!self.quiz.required_graduation) {
                            $("#map-quiz-" + self.quiz.id).addClass("passed");
                            $("#map-mobile-quiz-" + self.quiz.id).addClass(
                                "passed"
                            );
                            $("#map-quiz-" + self.quiz.id).removeClass(
                                "failed"
                            );
                            $("#map-mobile-quiz-" + self.quiz.id).removeClass(
                                "failed"
                            );
                        }
                    } else {
                        self.passedQuiz = response.quiz_data.passed;
                        self.repeated = response.quiz_data.repeated;
                        self.correct_responses = response.quiz_data.correct_responses;
                        self.percent = response.quiz_data.percent;
                        self.points = response.quiz_data.points;

                        if (self.passedQuiz) {
                            $("#map-quiz-" + self.quiz.id).addClass("passed");
                            $("#map-mobile-quiz-" + self.quiz.id).addClass(
                                "passed"
                            );
                            $("#map-quiz-" + self.quiz.id).removeClass(
                                "failed"
                            );
                            $("#map-mobile-quiz-" + self.quiz.id).removeClass(
                                "failed"
                            );
                        } else {
                            $("#map-quiz-" + self.quiz.id).addClass("failed");
                            $("#map-mobile-quiz-" + self.quiz.id).addClass(
                                "failed"
                            );
                        }

                        if (
                            self.quiz.repeat_times &&
                            self.quiz.repeat_times <= response.quiz_data.repeated
                        ) {
                            self.doneQuiz = true;
                        }
                        if (response.solutions) {
                            self.solutions = response.solutions;
                        }

                        for (const [key, value] of Object.entries(responses)) {
                            let qIdx = self.questions.findIndex(x => x.id === parseInt(key));
                            self.questions[qIdx].correct = value;
                            if (response.solutions) {
                                self.solutions = response.solutions;
                                if (["reorder", "reorder_images"].includes(self.questions[qIdx].type)) {
                                    self.questions[qIdx].userResponses = response.solutions[qIdx];
                                }
                            }
                        }
                        self.hasResponses = true;
                    }
                    this.quizDone();
                })
                .catch(err => {
                    this.$data.loader = false;
                });
        },
        updateQuizTime: function () {
            let warningMsg;
            let warningTitle;
            switch (this.quiz.quiz_type) {
                case "exam":
                    warningTitle = window.trans.course.examReached.title;
                    warningMsg = window.trans.course.examReached.warning;
                    if (this.quiz.time) {
                        warningMsg +=
                            "<br>" +
                            window.trans.course.examReached.warningTime +
                            " " +
                            this.quiz.time +
                            " " +
                            window.trans.course.examReached.warningTimeMinutes;
                    }
                    break;
                case "essay":
                    warningTitle = window.trans.course.essayReached.title;
                    warningMsg = window.trans.course.essayReached.warning;
                    if (this.quiz.time) {
                        warningMsg +=
                            "<br>" +
                            window.trans.course.essayReached.warningTime +
                            " " +
                            this.quiz.time +
                            " " +
                            window.trans.course.essayReached.warningTimeMinutes;
                    }
                    break;
                default:
                    warningTitle = window.trans.course.quizReached.title;
                    warningMsg = window.trans.course.quizReached.warning;
                    if (this.quiz.time) {
                        warningMsg +=
                            "<br>" +
                            window.trans.course.quizReached.warningTime +
                            " " +
                            this.quiz.time +
                            " " +
                            window.trans.course.quizReached.warningTimeMinutes;
                    }
                    break;
            }

            this.$swal
                .fire({
                    title: warningTitle,
                    icon: "warning",
                    html: warningMsg,
                    showCloseButton: false,
                    showCancelButton: true,
                    focusCancel: true,
                    confirmButtonText: window.trans.messages.Yes,
                    cancelButtonText: window.trans.messages.No,
                    reverseButtons: true,
                    focusConfirm: false,
                    onAfterClose: () => window.scrollTo(0,0),
                })
                .then(result => {
                    if (result.value) {
                        let self = this;
                        let date = moment().format("M/D/YYYY hh:mm:ss A");
                        let $end = "/api/update-quiz-time";

                        let data = {
                            time: date,
                            user: this.user,
                            quiz: this.quiz,
                            course_id: this.courseId,
                            studentCourseId: this.studentCourseId
                        };

                        axios
                            .post($end, data)
                            .then(response => {
                                self.deadline = moment()
                                    .add(self.quiz.time, "minutes")
                                    .format("M/D/YYYY hh:mm:ss A");
                                self.pauseTimer = false;
                            })
                            .catch(err => {
                                this.$data.loader = false;
                            });

                        // if (this.correctAnswers == this.questions.length) {
                        //     this.passedQuiz = true;
                        // }
                    } else {
                        this.$emit("navigate-back");
                    }
                });
        },
        quizDone: function (next) {
            this.stopTimer();
            this.submittingResults = false;
            this.$emit("quizDone", next);
        },
        getUserQuiz: function () {
            let $end =
                "/api/get-quiz-student/" +
                this.studentCourseId +
                "/" +
                this.user.id +
                "/" +
                this.quiz.id;
            let self = this;

            axios
                .get($end)
                .then(function (response) {
                    response = response.data;
                    // console.log(response)
                    let results = null;
                    if (response.results) {
                        results = response.results;
                    }

                    // get the quiz object so the parsing works the same
                    // although i added the results to the response
                    response = response.quiz;

                    //if no quiz
                    if (!response) {
                        self.updateQuizTime();
                    } else {
                        self.pauseTimer = false;
                    }

                    if (self.quiz.exam_set_clock && !results) {
                        self.deadline = moment()
                            .add(self.quiz.time, "minutes")
                            .format();
                    }
                    // console.log(response)
                    // console.log( response.id, response.start_time , response.responses);
                    if (response && response.start_time && !results) {
                        let today = moment();
                        let statedQuiz = moment(response.start_time);
                        let diff = moment.duration(today.diff(statedQuiz));
                        let diffMins = diff.asMinutes(); // minutes
                        self.deadline = moment(self.deadline)
                            .subtract(diffMins, "minutes")
                            .format("M/D/YYYY hh:mm:ss A");
                        // console.log(self.deadline);
                    }

                    if (response && !response.responses && response.saved_responses) {
                        self.getQuizQuestions(self.quiz.id).then(() => {
                            if (self.quiz.quiz_type === "essay") {
                                self.questions[0].userResponses = JSON.parse(response.saved_responses)[0] ?? "";
                            } else {
                                const responses = JSON.parse(response.saved_responses);
                                for (const [idx, response] of Object.entries(responses)) {
                                    let qidx = self.questions.findIndex(x => x.id === parseInt(idx));
                                    if (qidx >= 0) {
                                        self.questions[qidx].userResponses = response;
                                    }
                                }
                            }
                        });
                    }

                    self.repeated = response?.repeated ?? 0;
                    self.delayResultsUntil = response?.delay_results_until;

                    if (response && response.responses) {
                        // console.log(response)
                        // console.log(results)
                        if (self.quiz.quiz_type === "essay") {
                            self.doneQuiz = true;
                            self.hasResponses = true;

                            if (self.questions?.[0]) {
                                self.questions[0].userResponses = response.responses
                                ? JSON.parse(response.responses)[0] ?? ""
                                : "";
                            }

                            self.essayPending = response.pending;
                            self.essayTeacherResponse = response.teacher_response;
                            self.essayTeacherPoints = response.teacher_points;
                        } else {
                            if (
                                typeof response.responses != "undefined" &&
                                response.responses && results
                            ) {
                                self.hasResponses = true;

                                let responses = JSON.parse(response.responses);

                                // console.log(results);
                                //start parse results object
                                self.percent = results.percentage;
                                self.points = results.student_points;

                                for (const [idx, response] of Object.entries(responses)) {
                                    let qidx = self.questions.findIndex(x => x.id === parseInt(idx));
                                    if (qidx >= 0) {
                                        self.questions[qidx].userResponses = response;
                                    }
                                }

                                self.passedQuiz = response.passed;
                                self.correctAnswers = results.correctNo;
                                self.totalQuestions = results.questionCount;

                                if (results.solutions) {
                                    self.solutions = results.solutions;
                                }

                                if (results.correctResponses && self.questions.length) {
                                    for (const [key, value] of Object.entries(results.correctResponses)) {
                                        let qIdx = self.questions.findIndex(x => x.id === parseInt(key));
                                        if (qIdx >= 0) {
                                            self.questions[qIdx].correct = value;
                                            if (results.solutions) {
                                                if (["reorder", "reorder_images"].includes(self.questions[qIdx].type)) {
                                                    self.questions[qIdx].userResponses = results.solutions[qIdx];
                                                }
                                            }
                                        }
                                    }
                                }

                                if (
                                    self.quiz.repeat_times &&
                                    self.quiz.repeat_times <= response.repeated
                                ) {
                                    self.doneQuiz = true;
                                }
                                self.showResults = true;
                            } else {
                            }
                        }
                    }
                    if (self.quiz.exam_set_clock) {
                        self.stopTimer();
                        self.countdownTimer = setTimeout(self.countdown, 1);
                    }

                    if (!self.hasResponses && !response?.saved_responses && !self.questions.length) {
                        console.log('here');
                        self.getQuizQuestions(self.quiz.id);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.$data.loader = false;
                });
        },
        countdown() {
            let t = Date.parse(this.deadline) - Date.parse(new Date());
            let seconds = Math.floor((t / 1000) % 60);
            let minutes = Math.floor((t / 1000 / 60) % 60);
            let hours = Math.floor((t / (1000 * 60 * 60)) % 24);
            let days = Math.floor(t / (1000 * 60 * 60 * 24));

            if (t > 0 && !this.pauseTimer) {
                this.currentTime = {
                    total: t,
                    days: days,
                    hours: hours,
                    minutes: minutes,
                    seconds: seconds
                };
                this.stopTimer();
                this.countdownTimer = setTimeout(this.countdown, 1);
            } else if (!this.hasResponses && !this.pauseTimer && !this.submittingResults) {
                this.save();
                // this.currentTime = null;
            } else {
                this.stopTimer();
                this.countdownTimer = setTimeout(this.countdown, 500);
            }
        },
        saveQuizResponses() {
            let self = this;

            let $end = "/api/save-quiz-responses";

            let data = {
                questions: this.questions,
                user: this.user,
                quiz_id: this.quiz.id,
                course_id: this.courseId,
                studentCourseId: this.studentCourseId
            };

            axios
                .post($end, data)
                .then(response => {
                    response = response.data;
                    if(response.success) {
                        toastr.success(trans.course.student_save_results_success);
                    } else {
                        toastr.error(trans.course.student_save_results_error);
                    }
                })
                .catch(err => {
                    this.$data.loader = false;
                });
        },
    }
};
</script>
<style type="text/css">
body.swal2-shown.quiz > [aria-hidden="true"] {
    filter: blur(20px);
}

body.quiz > * {
    transition: 0.1s filter linear;
}
</style>
